import { render, staticRenderFns } from "./UcStatusBadge.yaml?vue&type=template&id=ef5f1570&component"
import script from "./UcStatusBadge.yaml?vue&type=script&lang=ts&component"
export * from "./UcStatusBadge.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports